import React from 'react';

import Button from 'components/Button';
import { openDecagonChat } from 'components/Decagon/Decagon.helpers';
import { bem } from 'helpers/class-name';

const { element } = bem('item-form');

export const getErrorSnackbarDescriptionWithContactLink = messageDescription => ({
  ...messageDescription,
  values: {
    'contact-us-link': chunks => (
      <Button
        onClick={openDecagonChat}
        styled="inline-link"
        className={element('snackbar-link')}
        type={Button.TYPES.BUTTON}>
        {chunks}
      </Button>
    ),
  },
});
